/**
 * Checks if a particular cookie category has been accepted.
 *
 * @param {string} category - The "name" of the cookie category.
 * @returns {boolean} Whether the cookie has been accepted.
 */

export function isLoaded() {
	return 'Cookiebot' in window;
}

export function getConsentForCookieCategory(category) {
	if (!isLoaded()) {
		return false;
	}

	if (category === 'analytics') {
		category = 'statistics';
	}

	return !!Cookiebot.consent[category];
}

/**
 * @param {Object} consents
 */
export function changeConsentForCookieCategories(consents) {
	if (!isLoaded()) {
		return;
	}

	for (let [key, value] of Object.entries(consents)) {
		if (key === 'analytics') {
			delete consents['analytics'];
			consents['statistics'] = value;
		}
	}

	let opts = Object.assign({}, {
		marketing: Cookiebot.consent.marketing,
		statistics: Cookiebot.consent.statistics,
		preferences: Cookiebot.consent.preferences,
	}, consents);

	Cookiebot.submitCustomConsent(opts.preferences, opts.statistics, opts.marketing);
}

/**
 * Updates consent for the given category.
 *
 * @param {string} name The name of the category to update.
 * @param {boolean} consent The consent value.
 */
export function changeConsentForCookieCategory(name, consent = false) {
	if (!isLoaded()) {
		return;
	}

	let opts = {
		marketing: Cookiebot.consent.marketing,
		statistics: Cookiebot.consent.statistics,
		preferences: Cookiebot.consent.preferences,
	};

	if (name === 'analytics') {
		name = 'statistics';
	}

	opts[name] = consent;

	Cookiebot.submitCustomConsent(opts.preferences, opts.statistics, opts.marketing);
}
